var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { captureException } from '@pegasus/sentry';
import { tracker } from '../utils/tracking';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var message = error.message, stack = error.stack, name = error.name;
        var componentName = this.props.componentName;
        // send to GA
        tracker.track('component_render_error', {
            component_name: componentName,
        });
        // send to sentry
        captureException(__assign({ message: message, stack: stack, name: name }, errorInfo));
    };
    ErrorBoundary.prototype.render = function () {
        var hasError = this.state.hasError;
        var _a = this.props, children = _a.children, FallbackUI = _a.fallbackUI;
        if (hasError) {
            return FallbackUI ? React.createElement(FallbackUI, null) : null;
        }
        return children;
    };
    return ErrorBoundary;
}(Component));
export { ErrorBoundary };
export default ErrorBoundary;
